import http from '../http'

/**
 * 登录获取token
 * @param param
 * @returns {AxiosPromise}
 */
export function userLogin(param) {
  return http({
    url: '/api/auth/login',
    method: 'post',
    data: param
  })
}

/**
 * 登录获取用户等级
 * @returns {AxiosPromise}
 */
export function getAuth() {
  return http({
    url: 'api/auth/user/',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/untils/api/login.js